import { FC } from 'react';
import type { ClasseDesvio } from '@/types/dashboards';
import { type ModoTema, visualFaixa } from './chartTheme';

/** Faixa de desvio sempre com ícone + rótulo — a cor nunca carrega o significado sozinha. */
const FaixaBadge: FC<{ classe: ClasseDesvio; modo: ModoTema }> = ({ classe, modo }) => {
  const v = visualFaixa(classe, modo);
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-content-primary">
      <span aria-hidden className="material-symbols-outlined text-[16px] leading-none" style={{ color: v.cor }}>
        {v.icone}
      </span>
      {v.rotulo}
    </span>
  );
};

export default FaixaBadge;
